<script setup>
import {
  CSidebarNav,
} from '@coreui/vue'

// Import the icon source
import iconCliUserSrc from '@/assets/icons/cil-user.svg';
import iconCilMessageDeliverySrc from '@/assets/icons/cil-message.svg';

const menu = ref([
  {
    title: '基本設定',
    icon: 'cil-settings',
    items: [
      // 店舗設定
      {name: '店舗設定', path: '/settings'},
      // 休日設定
      {name: '休日設定', path: '/settings/holiday'},
      // 営業時間設定
      {name: 'ユーザー登録設定', path: '/settings/user'},
      // Q&A設定
      {name: 'Q&A', path: '/settings/qa'},
      // Notification設定
      {name: '⾃動メッセージ', path: '/settings/notification-message-template'},
    ],
  },
  {
    title: '予約設定',
    icon: 'cil-calendar',
    items: [
      // サービス設定
      {name: 'Category', path: '/categories'},
      // メニュー設定
      {name: 'Menu', path: '/menu'},
    ],
  },
  {
    title: '予約管理',
    icon: 'cil-list',
    items: [
      // 予約一覧 (カレンダー)
      {name: '予約一覧', path: '/services'},
    ],
  },
  {
    title: '顧客管理',
    icon: () => `<img src="${iconCliUserSrc}" alt="Icon" class="me-2"/>`,
    items: [
      // 顧客一覧
      {name: '顧客一覧', path: '/users'},
    ],
  },
  {
    title: 'メッセージ配信',
    icon: () => `<img src="${iconCilMessageDeliverySrc}" alt="Icon" class="me-2"/>`,
    items: [
      // メッセージ配信
      {
        name: '新規',
        path: '/messages'
      },
      // 下書き一覧
      {
        name: '下書き',
        path: '/messages/draft',
        activeBase: '/messages/draft'},
      // テンプレート一覧
      {
        name: 'テンプレート',
        path: '/messages/template',
        activeBase: '/messages/template'
      },
      // 配信履歴
      {
        name: '配信履歴',
        path: '/messages/history',
        activeBase: '/messages/history'
      },
      // サンクス一覧
      {
        name: 'サンクス',
        path: '/messages/thankyou'
      },
      // リマインド一覧
      {
        name: 'リマインド',
        path: '/messages/remind'
      },
    ],
  }
]);
</script>

<template>
  <template v-for="item in menu" :key="item.title">
    <div class="my-2">
      <div class="mb-3">
        <div class="px-2 py-2 sidebar-nav-title-custom">
          <template v-if="typeof item.icon === 'function'">
            <span v-html="item.icon()"></span>
          </template>
          <template v-else>
            <CIcon :icon="item.icon" class="me-2"/>
          </template>
          {{ item.title }}
        </div>
      </div>
      <!-- Sub items -->
      <template v-for="i in item.items" :key="i.name">
        <RouterLink :to="i.path" class="text-decoration-none text-white">
          <div href="#" class="px-4 py-2 d-flex align-items-center justify-content-between"
               :class="isActiveRoute(i) ? 'active-sub' : ''">
            <div class="d-flex align-items-center"
                 :class="isActiveRoute(i) ? '' : 'px-2'"
                 :style="{frontSize: fontSize + 'px'}">
              <CIcon icon="cil-building" class="me-2"/>
              <span>{{ i.name }}</span>
            </div>
            <img :src="iconCilChevronRightAltSrc" alt="Icon" class="icon"/>
          </div>
        </RouterLink>
      </template>
    </div>
  </template>
</template>

<style scoped>
</style>

<script>
import {ref} from 'vue';

// Import Vue Router
export default {
  data() {
    const fontSize = ref(16); // Default font size
    return {
      // Path to your SVG image file
      iconCilChevronRightAltSrc: require('@/assets/icons/cil-chevron-right-alt.svg'),  // Or use a URL
      iconCliUserSrc: require('@/assets/icons/cil-user.svg'),
      iconCilUserColorSrc: require('@/assets/icons/cil-user-color.svg'),
      fontSize,
    };
  },
  methods: {
    // detect active route
    isActiveRoute(item) {
      const current = this.$route.path

      // exact match
      if (current === item.path) return true

      // match children via activeBase
      if (item.activeBase) {
        return current.startsWith(item.activeBase + '/')
      }

      return false
    }
  }
};
</script>

<style>
.sidebar-nav-title-custom {
  font-size: 18px;
}

.active-sub {
  background-color: #5EB093; /* giữ màu nền không đổi hoặc chọn phù hợp */
  border-left: 8px solid white;
}
</style>
